import { useState } from "react";
import { useTranslation } from "react-i18next";

import { initSentry } from "../../lib/sentry";
import { optInAnalytics } from "../../lib/posthog";

import { hasBeenPrompted, markPrompted, setAllConsent } from "./store";

export function FirstLaunchModal() {
  const { t } = useTranslation();
  const [open, setOpen] = useState<boolean>(() => !hasBeenPrompted());
  const [analytics, setAnalytics] = useState(false);
  const [crashReports, setCrashReports] = useState(false);

  if (!open) return null;

  function save() {
    setAllConsent({ analytics, crashReports });
    if (analytics) {
      optInAnalytics().catch((e) => console.error("[consent] optInAnalytics failed", e));
    }
    if (crashReports) {
      initSentry().catch((e) => console.error("[consent] initSentry failed", e));
    }
    markPrompted();
    setOpen(false);
  }

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-labelledby="consent-modal-title"
      className="fixed inset-0 z-50 flex items-center justify-center bg-bg-deep/70 p-4 backdrop-blur-sm"
    >
      <div className="surface-cinematic w-full max-w-sm p-6">
        <h2 id="consent-modal-title" className="display text-xl text-fg">
          {t("consent.modal_title")}
        </h2>
        <p className="mt-2 text-sm leading-relaxed text-fg-mute">
          {t("consent.modal_body")}
        </p>

        <div className="mt-5 space-y-3">
          <ToggleRow
            label={t("consent.analytics_label")}
            checked={analytics}
            onChange={setAnalytics}
          />
          <ToggleRow
            label={t("consent.crash_label")}
            checked={crashReports}
            onChange={setCrashReports}
          />
        </div>

        <button
          type="button"
          onClick={save}
          className="btn-volt mt-6 w-full px-4 py-2.5 text-sm"
        >
          {t("consent.modal_save")}
        </button>
      </div>
    </div>
  );
}

function ToggleRow({
  label,
  checked,
  onChange,
}: {
  label: string;
  checked: boolean;
  onChange: (next: boolean) => void;
}) {
  return (
    <label className="flex items-center justify-between gap-3 text-sm text-fg">
      <span>{label}</span>
      <input
        type="checkbox"
        aria-label={label}
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        className="h-4 w-4 rounded border border-line-strong bg-surface-sunk accent-volt"
      />
    </label>
  );
}
